<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!-- page content -->
            <div class="admin-page-content">
                <!-- Forms -->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="name" placeholder="Enter Name" v-model="name">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{nameError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <!-- excede customer id -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Excede Customer Id :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input class="form-control" id="excedeCustomerId" placeholder="Enter Excede Customer Id" v-model="excedeCustomerId">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{excedeCustomerIdError}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="email" placeholder="Enter Email" v-model="email">
                                <div class="requiredstar">*</div>
                                <template v-if="isNonVVGDealer == 'NO'">
                                    <input type="checkbox" id="setPrimartEmail" name="setPrimartEmail" value="setPrimartEmail">
                                    <label>Set Email as Primary Email</label>
                                </template>
                                <span class="text-danger">{{emailError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <!-- Primary Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Primary Email : </div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input class="form-control" id="primaryEmail" placeholder="Enter Primary Email" v-model="primaryEmail">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{primaryEmailError}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Contact : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="contact" placeholder="Enter Contact" v-model="contact">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{contactError}}</span>
                            </div>
                        </div>
                        <!-- Secondary Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Secondary Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="secondaryEmail" placeholder="Enter Secondary Email" v-model="secondaryEmail">
                                <span class="text-danger">{{secondaryEmailError}}</span>
                            </div>
                        </div>
                        <!-- Secondary Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Secondary Contact : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="secondaryContact" placeholder="Enter Secondary Contact" v-model="secondaryContact">
                                <span class="text-danger">{{secondaryContactError}}</span>
                            </div>
                        </div>
                        <!-- Third Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Third Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="thirdEmail" placeholder="Enter Third Email" v-model="thirdEmail">
                                <span class="text-danger">{{thirdEmailError}}</span>
                            </div>
                        </div>
                        <!-- Third Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Third Contact : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="thirdContact" placeholder="Enter Third Contact" v-model="thirdContact">
                                <span class="text-danger">{{thirdContactError}}</span>
                            </div>
                        </div>
                        <!-- Address Line 1 -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Address Line 1 : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="addressLine1" placeholder="Enter Address Line 1" v-model="addressLine1">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{addressLine1Error}}</span>
                            </div>
                        </div>
                        <!-- Address Line 2 -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Address Line 2 : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="addressLine2" placeholder="Enter Address Line 2" v-model="addressLine2">
                            </div>
                        </div>
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">State :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="stateId"
                                    name="stateId"
                                    id="stateId"
                                    label="name"
                                    :filterable="true"
                                    :options="stateOption"
                                    @input="onChnageState()"
                                    :clearable="false"
                                    placeholder="Select State">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{stateError}}</span>
                            </div>
                        </div>
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId"
                                    name="locationId"
                                    id="locationId"
                                    label="name"
                                    :filterable="true"
                                    :options="locationOption"
                                    @input="onChnageLocation()"
                                    :clearable="false"
                                    placeholder="Select Location">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{locationError}}</span>
                            </div>
                        </div>
                        <!-- Zip Code -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Zip Code : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="zipCode" placeholder="Enter Zip Code" v-model="zipCode">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{zipCodeError}}</span>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <!-- Password -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Password : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="toggle-password" type="password" placeholder="Enter Password" class="form-control" name="password" v-model="password">
                                <div class="requiredstarPassword">*</div>
                                <span toggle="#toggle-password" class="fa fa-lg fa-eye field-icon toggle-password"></span>
                                <span class="text-danger">{{passwordError}}</span>
                            </div>
                        </div>
                        <!-- Confirm Password -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Confirm Password : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="toggle-password-confirm" type="password" class="form-control" name="confirmPassword" placeholder="Confirm Password" v-model="confirmPassword">
                                <div class="requiredstarConfirmPassword">*</div>
                                <span toggle="#toggle-password-confirm" class="fa fa-lg fa-eye field-icon toggle-password-confirm"></span>
                                <span class="text-danger">{{confirmPasswordError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <div class="col-6 forms-block">
                                <div class="paddingleft0">
                                    <div class="form-label">
                                        <label class="container" style="width 175px; padding: 0px !important;">
                                            <input type="checkbox" id="1" value="1" v-model="isAllowEnterPO" class="mr-2">
                                            Allow to enter PO# number in Mobile Application
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 forms-block">
                                <div class="paddingleft0">
                                    <div class="form-label">
                                        <label class="container" style="width 175px; padding: 0px !important;">
                                            <input type="checkbox" id="1" value="1" v-model="isPinnacle" class="mr-2">
                                            Pinnacle Customer
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 forms-block">
                                <div class="paddingleft0">
                                    <div class="form-label">
                                        <label class="container" style="width 175px; padding: 0px !important;">
                                            <input type="checkbox" id="1" value="1" v-model="auditQtyAdjust" class="mr-2">
                                            Adjustment On Audit
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row clearfix"></div>
                            <div class="row clearfix"></div>
                        </template>
                        <!-- Process -->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">
                                    <label class="container" style="width 175px; padding: 0px !important;">
                                        <input type="radio" id="1" value="1" v-model="process">
                                        1st Step Process
                                    </label>
                                    <label class="container" style="width 175px; padding: 0px !important;">
                                        <input type="radio" id="2" value="2" v-model="process">
                                        2nd Step Process
                                    </label>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- Error Alert -->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!-- Buttons -->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="addUpdateCustomer()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="addUpdateCustomer(flag='Save and Continue')">
                        <!-- <input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateCustomer()"></input> -->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="buttonBack">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!-- page content -->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';

    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateCustomer',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add Customer",
                isAllowEnterPO: 0,
                isPinnacle: 0,
                auditQtyAdjust:0,
                name : '',
                nameError : "",
                excedeCustomerId : "",
                excedeCustomerIdError : "",
                email : "",
                emailError : "",
                primaryEmail : "",
                primaryEmailError : "",
                secondaryEmail : "",
                secondaryEmailError : "",
                thirdEmail : "",
                thirdEmailError : "",
                password : "",
                passwordError : "",
                confirmPassword : "",
                confirmPasswordError : "",

                allPermissions : [],
                checkedPermissions : [],

                addressLine1: "",
                addressLine1Error: "",
                addressLine2: "",
                
                stateOption : [],
                stateError : "",
                stateId: {
                    'name' : "",
                    'id' : "",
                },

                locationOption : [],
                locationError : "",
                locationId: {
                    'name' : "",
                    'id' : "",
                },
                zipCode: "",
                zipCodeError: "",
                contact : "",
                contactError : "",
                secondaryContact : "",
                secondaryContactError : "",
                thirdContact : "",
                thirdContactError : "",


                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,
                process: 2,
                isNonVVGDealer: 'NO',
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listCustomer");
        },
        watch: {
            excedeCustomerId: function(excedeCustomerId) {
                if(typeof(self.$route.params.id) == 'undefined') {
                    if(excedeCustomerId.length > 5) {
                        self.checkCustomerInExcedeServer();
                    }
                }
            }
        },
        mounted: function () {
            // EventBus.$emit('showHeader', true);
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            $("#alertError").hide();
            self.getAllPermissions();
            self.removeErrorMessageOnInput();

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'update-customer') {
                if (segments[2]) {
                    self.getCustomerDetailById();
                    self.buttonNames.save = "Update";
                    $("#addAndContinueBenifitBtn").hide();
                    // $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Customer";
                    $(".requiredstarPassword").hide();
                    $(".requiredstarConfirmPassword").hide();
                }
            } else {
                $(".requiredstarPassword").show();
                $(".requiredstarConfirmPassword").show();
            }

            self.getAllLocationList();
            self.getAllStateList();
            self.toggelPasswordConfirmPassword();
            self.setPrimaryEmailAsEmail();

        },
        beforeDestroy() {
            // EventBus.$off('all-permissions');
        },
        methods: {
            checkCustomerInExcedeServer: function() {
                var data = {
                    excede_customer_id : self.excedeCustomerId,
                }
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post('/customer/checkin/excedeserver', data, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            self.name = response.data.content.name;
                            self.excedeCustomerId = response.data.content.excede_customer_id;
                            self.email = response.data.content.email;
                            self.contact = response.data.content.contact;
                            self.secondaryContact = response.data.content.secondary_contact;
                            self.secondaryEmail = response.data.content.secondary_email;
                            self.thirdContact = response.data.content.third_contact;
                            self.thirdEmail = response.data.content.third_email;
                            self.addressLine1 = response.data.content.address_line_1;
                            self.addressLine2 = response.data.content.address_line_2;
                            self.locationId = {id: response.data.content.location_id, name: response.data.content.location_name};
                            self.stateId = {id: response.data.content.state_id, name: response.data.content.state_name};
                            self.isPinnacle = response.data.content.is_pinnacle;
                            self.auditQtyAdjust = response.data.content.audit_qty_adjust;
                            self.zipCode = response.data.content.zip_code;
                        }
                    })
                    .catch(function (err) {
                        //console.log(err);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                self.catchHandler(error);
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            setPrimaryEmailAsEmail : function () {
                $('#setPrimartEmail').on('change',function(){
                    var _val = $(this).is(':checked') ? 'checked' : 'unchecked';
                    if (_val == "checked") {
                        if (self.email) {
                            self.primaryEmail = self.email;
                        }
                    } else {
                        self.primaryEmail = "";
                    }
                });
            },
            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#name").keyup(function () {
                    self.nameError = "";
                });
                $("#excedeCustomerId").keyup(function () {
                    self.excedeCustomerIdError = "";
                });

                $("#email").keyup(function () {
                    self.emailError = "";
                });

                $("#primaryEmail").keyup(function () {
                    document.getElementById("setPrimartEmail").checked = false;
                    self.primaryEmailError = "";
                });

                $("#secondaryEmail").keyup(function () {
                    self.secondaryEmailError = "";
                });

                $("#thirdEmail").keyup(function () {
                    self.thirdEmailError = "";
                });

                $("#contact").keyup(function () {
                    self.contactError = "";
                });
                $("#secondaryContact").keyup(function () {
                    self.secondaryContactError = "";
                });
                $("#thirdContact").keyup(function () {
                    self.thirdContactError = "";
                });

                $("#toggle-password").keyup(function () {
                    self.passwordError = "";
                });

                $("#toggle-password-confirm").keyup(function () {
                    self.confirmPasswordError = "";
                });
                $("#addressLine1").keyup(function () {
                    self.addressLine1Error = "";
                });
                $("#zipCode").keyup(function () {
                    self.zipCodeError = "";
                });
            },
            toggelPasswordConfirmPassword : function () {
                $(".toggle-password").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });

                $(".toggle-password-confirm").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });
            },
            getAllPermissionsss() {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.allPermissions = data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            showAlertOnSave: function(alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack: function() {
                self.$router.push('/list-customer');
            },
            onChnageState: function() {
                self.stateError = "";
            },
            onChnageLocation: function() {
                self.locationError = "";
            },
            clearDataOnSaveAndContinue: function() {
                self.name = '';
                self.excedeCustomerId = '';
                self.email = "";
                self.primaryEmail = "";
                self.secondaryEmail = "";
                self.thirdEmail = "";
                self.locationId = {
                    'name' : "",
                    'id' : "",
                };
                self.stateId = {
                    'name' : "",
                    'id' : "",
                };
                self.contact = "";
                self.secondaryContact = "";
                self.thirdContact = "";
                self.password = "";
                self.confirmPassword = "";
                self.addressLine1 = "";
                self.addressLine2 = "";
                self.zipCode = "";
                self.isAllowEnterPO = 0;
                self.isPinnacle = 0;
                self.auditQtyAdjust = 0;
            },
            onChnageTimezone: function() {
                self.timezoneError = "";
            },
            checkForm: function() {
                var checked = true;
                console.log(self.process);
                var path = window.location.pathname;
                var segments = path.split("/");

                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.isNonVVGDealer == 'NO') {
                    if (!self.excedeCustomerId) {
                        self.excedeCustomerIdError = "excede Customer Id Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                
                if (!self.addressLine1) {
                    self.addressLine1Error = "Address Line 1 Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.zipCode) {
                    self.zipCodeError = "Zip Code Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.locationId == null || !self.locationId.id || self.locationId.id === 0) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                
                if (self.stateId == null || !self.stateId.id || self.stateId.id === 0) {
                    self.stateError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.isNonVVGDealer == 'NO') {
                    if (!self.primaryEmail) {
                        self.primaryEmailError = "Primary Email Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.primaryEmail && !self.validEmail(self.primaryEmail)) {
                        self.primaryEmailError = "Please Enter Valid Primary Email";
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                if (self.secondaryEmail && !self.validEmail(self.secondaryEmail)) {
                    self.secondaryEmailError = "Please Enter Valid Secondary Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.thirdEmail && !self.validEmail(self.thirdEmail)) {
                    self.thirdEmailError = "Please Enter Valid Third Email";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.contact) {
                    self.contactError = "Contact Required";
                    if (checked) {
                        checked = false;
                    }
                } else if(self.contact && !self.allnumeric(self.contact)) {
                    self.contactError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }

                } else if (self.contact && !self.checkContactNoLength(self.contact)) {
                    self.contactError = "Max Length is 13";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.secondaryContact && !self.checkContactNoLength(self.secondaryContact)) {
                    self.secondaryContactError = "Max Length is 13";
                    if (checked) {
                        checked = false;
                    }
                } else if(self.secondaryContact && !self.allnumeric(self.secondaryContact)) {
                    self.secondaryContactError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }

                }

                if (self.thirdContact && !self.checkContactNoLength(self.thirdContact)) {
                    self.thirdContactError = "Max Length is 13";
                    if (checked) {
                        checked = false;
                    }
                } else if(self.thirdContact && !self.allnumeric(self.thirdContact)) {
                    self.thirdContactError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }

                }

                if (segments[1] == "add-customer") {
                    if (!self.password) {
                        self.passwordError = "Password Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                if (segments[1] == "add-customer") {
                    if (self.password && !self.confirmPassword) {
                        self.confirmPasswordError = "Confirm Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                        self.confirmPasswordError = "Password and Confirm Password do not match";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if (self.password && !self.confirmPassword) {
                        self.confirmPasswordError = "Confirm Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.password) {
                        self.passwordError = "Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                        self.confirmPasswordError = "Password and Confirm Password do not match";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            allnumeric: function(inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },
            checkContactNoLength: function(val) {
                if (val.length > 13) {
                    return false;
                } else {
                    return true;
                }
            },
            checkPasswordAndConfirmPassword: function(password, confirmPassword) {
                if (password != confirmPassword) {
                    return false;
                } else {
                    return true;
                }
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            getCustomerDetailById: function() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    customer_id: segments[2],
                };

                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };

                HTTP.post('/customer-details-by-id', fields, config)
                    .then(response => {
                        self.name = response.data.customer.name;
                        self.excedeCustomerId = response.data.customer.excede_customer_id;
                        self.email = response.data.customer.email;
                        self.primaryEmail = response.data.customer.primary_email;
                        self.secondaryEmail = response.data.customer.secondary_email;
                        self.thirdEmail = response.data.customer.third_email;
                        self.contact = response.data.customer.primary_contact;
                        self.secondaryContact = response.data.customer.secondary_contact;
                        self.thirdContact = response.data.customer.third_contact;
                        self.locationId = {
                            'id' : response.data.customer.location_id,
                            'name' : response.data.customer.location_name,
                        }
                        self.stateId = {
                            'id' : response.data.customer.state_id,
                            'name' : response.data.customer.state_name,
                        }
                        self.addressLine1 = response.data.customer.address_line_1;
                        self.addressLine2 = response.data.customer.address_line_2;
                        self.zipCode = response.data.customer.zip_code;
                        self.process = response.data.customer.process;
                        self.isAllowEnterPO = response.data.customer.is_allow_enter_po;
                        self.isPinnacle = response.data.customer.is_pinnacle;
                        self.auditQtyAdjust = response.data.customer.audit_qty_adjust;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            addUpdateCustomer(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };

                        if (segments[1] == 'update-customer') {
                            if (segments[2]) {
                                var data = {
                                    name: self.name,
                                    excede_customer_id: self.excedeCustomerId,
                                    email: self.email,
                                    primary_email: self.primaryEmail,
                                    secondary_email: self.secondaryEmail,
                                    third_email: self.thirdEmail,
                                    location_id : self.locationId.id,
                                    state_id : self.stateId.id,
                                    contact : self.contact,
                                    secondary_contact : self.secondaryContact,
                                    third_contact : self.thirdContact,
                                    password : self.password,
                                    address_line_1: self.addressLine1,
                                    address_line_2: self.addressLine2,
                                    zip_code: self.zipCode,
                                    process: self.process,
                                    id: segments[2],
                                    is_master_customer: 0,
                                    is_allow_enter_po: self.isAllowEnterPO ? 1 : 0,
                                    is_pinnacle: self.isPinnacle ? 1 : 0,
                                    audit_qty_adjust : self.auditQtyAdjust ? 1 : 0,
                                    is_non_vvg_dealer: (self.isNonVVGDealer == 'YES') ? 1 : 0,
                                };
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = {
                                name: self.name,
                                excede_customer_id: self.excedeCustomerId,
                                email: self.email,
                                primary_email: self.primaryEmail,
                                secondary_email: self.secondaryEmail,
                                third_email: self.thirdEmail,
                                location_id : self.locationId.id,
                                state_id : self.stateId.id,
                                contact : self.contact,
                                secondary_contact : self.secondaryContact,
                                third_contact : self.thirdContact,
                                password : self.password,
                                confirm_password : self.confirmPassword,
                                address_line_1: self.addressLine1,
                                address_line_2: self.addressLine2,
                                zip_code: self.zipCode,
                                process: self.process,
                                is_master_customer: 0,
                                is_allow_enter_po: self.isAllowEnterPO ? 1 : 0,
                                is_pinnacle: self.isPinnacle ? 1 : 0,
                                audit_qty_adjust : self.auditQtyAdjust ? 1 : 0,
                                is_non_vvg_dealer: (self.isNonVVGDealer == 'YES') ? 1 : 0,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }
                        HTTP.post("/add-update-customer", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-customer') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }

                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if (segments[1] == 'update-customer') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }
    }
    EventBus.$on('all-location-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.locationOption = response;
        }
    });
    EventBus.$on('all-state-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.stateOption = response;
        }
    });
    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            if (segments[1] === 'update-customer') {
                // self.getCustomerDetailById();
            }
            // self.allPermissions = allPermissions;
        }
    });
</script>

<style>
    .field-icon {
        float: right;
        margin-right: 8px;
        margin-top: -23px;
        position: relative;
        z-index: 2;
        cursor:pointer;
    }
    .container{
        padding-top:50px;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Customer/AddUpdateCustomer.vue